import { create } from "zustand";
import { shallow } from "zustand/shallow";

const initialState = {
    QUANTARA_TEAM: [74, 70, 76, 136, 84, 71, 75, 73, 154, 148, "74", "70", "76", "136", "84", "71", "75", "73", "154", "148"],
    INDEPENDENT_USER: [70, "70", 148, "148", 77, "77"],
    cmsAllData: [],
    cmsData: [],
    cmsLoading: false,
    swiperData: {},
    authToken: null,
    memberData: [],
    profileData: {},
    notificationDetails: [],
    notificationCount: 0,
    registerPopup: false,
    communityPostType: null,
    edisonStatus: 0,
    authUserId: 0,
    reportPopup: false,
    reportId: "",
    report_type: ""
};

const useCommonGlobalStore = create((set) => ({
    ...initialState,

    setCommonZustGlobalState: (payload) => { // setCommonZustGlobalState
        set((state) => ({
            ...state,
            ...payload,
        }));
    },

}));

export const commonZustandGlobalSelector = (state) => state;
export { shallow };
export default useCommonGlobalStore;
